var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket",
    transform: "translate(-510 -490)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 72,
    height: 72,
    rx: 12,
    transform: "translate(510 490)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ticket_icon",
    "data-name": "ticket icon",
    transform: "translate(527.333 514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 48,
    height: 48,
    transform: "translate(-5.333 -12)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M31.7,21.849H5.635A5.641,5.641,0,0,1,0,16.214V15.2a.89.89,0,0,1,1.779,0v1.014A3.86,3.86,0,0,0,5.635,20.07H31.7a3.86,3.86,0,0,0,3.856-3.856v-.986a.89.89,0,1,1,1.779,0v.986A5.641,5.641,0,0,1,31.7,21.849Z",
    transform: "translate(0 2.666)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M.89,7.816A.89.89,0,0,1,0,6.926V5.635A5.641,5.641,0,0,1,5.635,0H31.7a5.641,5.641,0,0,1,5.635,5.635V6.741a.89.89,0,0,1-1.779,0V5.635A3.86,3.86,0,0,0,31.7,1.779H5.635A3.86,3.86,0,0,0,1.779,5.635V6.926A.89.89,0,0,1,.89,7.816Z",
    transform: "translate(0 0)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M31.69,17.479a6.177,6.177,0,1,1,0-12.353.89.89,0,1,1,0,1.779,4.4,4.4,0,1,0,0,8.794.89.89,0,1,1,0,1.779Z",
    transform: "translate(4.753 0.955)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M.89,17.479a.89.89,0,0,1,0-1.779,4.4,4.4,0,0,0,0-8.794.89.89,0,1,1,0-1.779,6.177,6.177,0,0,1,0,12.353Z",
    transform: "translate(0 0.955)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_35",
    "data-name": "Line 35",
    d: "M.14,22.5a.89.89,0,0,1-.89-.89V.14a.89.89,0,1,1,1.779,0V21.606A.89.89,0,0,1,.14,22.5Z",
    transform: "translate(10.68 1.768)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_36",
    "data-name": "Line 36",
    d: "M.14,10.245a.89.89,0,0,1-.89-.89V.14a.89.89,0,1,1,1.779,0V9.355A.89.89,0,0,1,.14,10.245Z",
    transform: "translate(21.609 7.893)",
    fill: "#006"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.1b4ef7381128e692f92df285180d9dfa.svg";
export { ForwardRef as ReactComponent };